module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Medium-22a99d36f90cc52d2914adca813e56ed.woff2";